var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIconSquare = function SvgSearchIconSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.014 12.488c0-3.03-2.468-5.488-5.5-5.488C9.487 7 7 9.47 7 12.488c0 3.02 2.474 5.488 5.5 5.488l.27-.006.266-.02a5.43 5.43 0 0 0 2.673-1.009l.047-.037 1.933 1.85.083.073a.82.82 0 0 0 .5.173.83.83 0 0 0 .588-.249l.077-.083.063-.09a.82.82 0 0 0-.145-1.006l-1.91-1.842.032-.044a5.5 5.5 0 0 0 1.037-3.198m-9.34 0A3.82 3.82 0 0 1 12.5 8.672c2.104 0 3.825 1.717 3.825 3.816A3.835 3.835 0 0 1 12.5 16.32a3.825 3.825 0 0 1-3.826-3.832",
    clipRule: "evenodd"
  })));
};
export default SvgSearchIconSquare;